import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const win11StartMenuDark = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1,
  type: 'Windows11StartDark',
  associationType: 'TransparentLogo',
  simplifiedType: 'TransparentLogo',
  imagePreviewHeight: 160,
  className: 'app-ad-start-menu',
  logoHeight: 27,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [300, 300],
  maxSize: [1000, 1000],
  localizedText: {
    previewTypeStringKey: _TL_('Windows 11 Start Menu (Dark mode)'),
    stringKey: _TL_('Windows 11 Start Menu (Dark mode)'),
  },
  previewSettings: {
    previewContentClassName: 'app-ad-start-menu',
    showLogo: false,
    showShortHeadline: true,
    showWin11StartLight: false,
    showWin11StartDark: true,
    showWin10StartLight: false,
    showWin10StartDark: false,
    showWinStore: false,
    showBusinessName: true,
    showBusinessNameFirst: true,
    showImage: true,
    hideLabel: true,
  },
  styleOverrides: {
    cardParent: {
      '& .responsive-ad-preview-content': {
        width: '418px !important',
        height: '300px !important',
        background: '#262632 !important',
      },
      '& .image-container': {
        position: 'absolute',
        top: 77,
        left: 72,
        width: '35px !important',
        height: '35px !important',
        borderRadius: 2.65,
        '& .cropped-image-view': {
          height: '35px !important',
          width: '35px !important',
          position: 'absolute',
          top: 0,
          borderRadius: 2.65,

          '& img': {
            width: '35px !important',
            height: '35px !important',
            marginLeft: '0 !important',
            objectFit: 'cover',
          },
        },
      },
      '& .text-container-apl': {
        position: 'absolute',
        top: 76,
        left: 117,
        '& .short-headline': {
          position: 'absolute',
          top: 18,
          fontSize: 13,
          fontWeight: 400,
          width: 225,
          color: '#BBBBBB',
        },
        '& .business-name-with-ads': {
          position: 'absolute',
          top: 0,
          marginTop: 0,
          color: '#FFFFFFE4',
          fontWeight: 600,
          fontSize: 13,
          width: 220,
          display: 'block',
          '-webkit-line-clamp': 1,
          '-webkit-box-orient': 'vertical',
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
        },
      },
    },
  },
};

export default win11StartMenuDark;
